// import React, { useState, useEffect } from "react";
// import MovieServices from "../../services/externalServices/TicketServices/moviesServices";
// import TheatreServices from "../../services/externalServices/TicketServices/theatreServices";
// import ScreenLayoutServices from "../../services/externalServices/TicketServices/screenLayoutServices";
// import { Ticket } from "lucide-react";
// import axios from "axios";

// const ShowPerformance = () => {
//   const [movieName, setMovieName] = useState("");
//   const [theatreName, setTheatreName] = useState("");
//   const [showDate, setShowDate] = useState("");
//   const [hour, setHour] = useState("");
//   const [minute, setMinute] = useState("");
//   const [period, setPeriod] = useState("");
//   const [summaryData, setSummaryData] = useState(null);
//   const [movies, setMovies] = useState([]);
//   const [theatres, setTheatres] = useState([]);
//   const [theatreId, setTheatreId] = useState("");
//   const [showTimings, setShowTimings] = useState([]);
//   const [error, setError] = useState(false);
//   const { role = "", accessList = [] } = JSON.parse(
//     localStorage.getItem("admin")
//   );

//   const isTicketAdmin = role === "ticket-admin";
//   console.log("isTicketAdmin", isTicketAdmin);
//   const theatreName1 = accessList?.[0]; // assuming accessList contains theatre name

//   //   const theatreName1 = accessList?.[0];

//   useEffect(() => {
//     const fetchData = async () => {
//       const theatreName = theatreName1;
//       const movies = await MovieServices.getMoviesForShowPerformance(
//         theatreName
//       );
//       setMovies(movies);

//       const res = await TheatreServices.getTheatres();
//       if (Array.isArray(res)) {
//         let filtered = res;
//         if (role === "ticket-admin")
//           filtered = res.filter((t) => accessList.includes(t.name));
//         setTheatres(filtered);

//         if (filtered.length > 0) {
//           setTheatreId(filtered[0]._id); // ✅ Set ID properly
//           setTheatreName(filtered[0].name); // ✅ Set name properly
//         }
//       }
//     };
//     fetchData();
//   }, []);

//   const handleSummarySubmit = async (e) => {
//     e.preventDefault();
//     const formattedTime = `${hour}:${minute} ${period}`;
//     const params = {
//       movieName,
//       theatreName,
//       showDate: showDate.replace(/-/g, "/"),
//       showTime: formattedTime,
//     };
//     try {
//       const res = await ScreenLayoutServices.getSummary(params);
//       console.log("summaryData", res);

//       setSummaryData(res);
//     } catch (err) {
//       console.error("Error fetching summary:", err);
//     }
//   };

//   const fetchShowTimings = async (selectedMovieName, theatreId, showDate) => {
//     const movie = movies.find((m) => m.name === selectedMovieName);
//     console.log("movie", movie);
//     console.log("selectedTheatreName", theatreId);

//     if (movie && theatreId) {
//       try {
//         // const response = await MovieServices.getTheatersAndShowTimings(
//         //   movie._id,
//         //   selectedTheatreName
//         // );
//         const response = await ScreenLayoutServices.getShowTimings({
//           theatreId,
//           showtimeId: movie._id, // ❗ Change this if movie._id ≠ showtimeId
//           date: showDate,
//         });

//         console.log("details", response); // Check the whole array

//         // Assuming response is an array of movie-theatre associations
//         // const matchingMovieEntry = response.find(
//         //   (entry) => entry.movieId === movie._id
//         // );

//         // const theatreMatch = matchingMovieEntry?.theatreDetails?.find(
//         //   (t) => t.theatreId?.name ===
//         // );

//         // console.log("theatreMatch", theatreMatch);

//         setShowTimings(response);
//       } catch (error) {
//         console.error("Error fetching show timings:", error);
//         setError(true);
//         setShowTimings([]);
//       }
//     } else {
//       setShowTimings([]);
//     }
//   };

//   const seatPricePairs = summaryData?.bookedSeatList?.map((seat, index) => ({
//     seat,
//     price: summaryData.bookedPrices[index],
//     section: seat.split(" ")[0], // Extract section (Platinum, Gold, Silver)
//   }));

//   // Calculate total price per section
//   const sectionTotals = seatPricePairs?.reduce((acc, { section, price }) => {
//     if (!acc[section]) {
//       acc[section] = { total: 0, seats: 0 };
//     }
//     acc[section].total += price;
//     acc[section].seats += 1;
//     return acc;
//   }, {});

//   // Define display order (Platinum → Silver → Gold)
//   const sectionOrder = ["Platinum", "Silver", "Gold"];

//   return (
//     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//       {/* Show Performance Card */}
//       <div className="bg-white rounded-xl shadow-md p-6">
//         <h2 className="text-xl font-semibold mb-4">Show Performance</h2>

//         <form onSubmit={handleSummarySubmit} className="space-y-4">
//           <div className="space-y-2">
//             <label className="block text-sm font-medium text-gray-700">
//               Movie
//             </label>
//             <select
//               value={movieName}
//               onChange={(e) => {
//                 const selectedMovieName = e.target.value;
//                 setMovieName(selectedMovieName);
//                 fetchShowTimings(selectedMovieName, theatreId);
//               }}
//               className="w-full p-2 border border-gray-300 rounded-md"
//               required
//             >
//               <option value="">Select a movie</option>
//               {movies.map((m) => (
//                 <option key={m._id} value={m.name}>
//                   {m.name}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <div className="space-y-2">
//             <label className="block text-sm font-medium text-gray-700">
//               Theatre
//             </label>
//             <select
//               value={theatreId}
//               onChange={(e) => {
//                 const selectedTheatreId = e.target.value;
//                 console.log("selectedTheatreId", selectedTheatreId);
//                 const selectedTheatre = theatres.find(
//                   (t) => t._id === selectedTheatreId
//                 );
//                 setTheatreId(selectedTheatreId); // Correctly set the ID as a string
//                 setTheatreName(selectedTheatre?.name || "");
//                 fetchShowTimings(movieName, selectedTheatreId, showDate);
//               }}
//             >
//               <option value="">Select a theatre</option>
//               {theatres.map((t) => (
//                 <option key={t._id} value={t._id}>
//                   {t.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="space-y-2">
//             <label className="block text-sm font-medium text-gray-700">
//               Show Date
//             </label>
//             <input
//               type="date"
//               value={showDate}
//               onChange={(e) => {
//                 const selectedDate = e.target.value;
//                 setShowDate(selectedDate);
//                 fetchShowTimings(movieName, theatreId, selectedDate);
//               }}
//               className="w-full p-2 border border-gray-300 rounded-md"
//               required
//             />
//           </div>

//           <div className="grid grid-cols-3 gap-2">
//             {showTimings.length > 0 ? (
//               <div className="space-y-2 col-span-3">
//                 <label className="block text-sm font-medium text-gray-700">
//                   Show Time
//                 </label>
//                 <div className="flex flex-wrap gap-3">
//                   {showTimings.map((timeObj, idx) => (
//                     <label key={idx} className="flex items-center space-x-2">
//                       <input
//                         type="checkbox"
//                         value={timeObj.time}
//                         checked={`${hour}:${minute} ${period}` === timeObj.time}
//                         onChange={(e) => {
//                           if (e.target.checked) {
//                             const [timePart, ampm] = timeObj.time.split(" ");
//                             const [h, m] = timePart.split(":");
//                             setHour(h);
//                             setMinute(m);
//                             setPeriod(ampm);
//                           } else {
//                             setHour("");
//                             setMinute("");
//                             setPeriod("");
//                           }
//                         }}
//                         className="form-checkbox text-blue-600"
//                       />
//                       <span className="text-sm text-gray-700">
//                         {timeObj.time}
//                       </span>
//                     </label>
//                   ))}
//                 </div>
//               </div>
//             ) : (
//               <div className="col-span-3 text-sm text-gray-500 space-y-1">
//                 {!movieName && <p>Please select a movie to view showtimes.</p>}
//                 {!theatreId && <p>Please select a theatre.</p>}
//                 {!showDate && <p>Please select a date.</p>}
//                 {movieName && theatreId && showDate && !error && (
//                   <p>
//                     No showtimes found for the selected movie, theatre, and
//                     date.
//                   </p>
//                 )}
//                 {error && (
//                   <p className="text-red-500">
//                     Error fetching showtimes. Please try again.
//                   </p>
//                 )}
//               </div>
//             )}
//           </div>

//           <button
//             type="submit"
//             className="w-full bg-black text-white py-2 px-4 rounded-md hover:bg-gray-800 transition-colors"
//           >
//             Get Summary
//           </button>
//         </form>
//       </div>

//       {/* Ticket Summary Card */}
//       {summaryData && (
//         <div className="bg-white rounded-xl shadow-md p-6">
//           <h2 className="text-xl font-semibold mb-4 flex gap-2 items-center">
//             <Ticket /> Ticket Summary
//           </h2>
//           <div className="space-y-4">
//             <div className="flex justify-between">
//               <span className="font-medium">Booked Seats:</span>
//               <span className="text-yellow-500">
//                 {summaryData.totalBookedSeats}
//               </span>
//             </div>
//             <div className="flex justify-between">
//               <span className="font-medium">Total Earnings:</span>
//               <span className="text-green-500">
//                 ₹{summaryData.totalEarnings}
//               </span>
//             </div>

//             <div>
//               <h3 className="font-medium mb-2">Seats & Pricing:</h3>
//               <div className="space-y-3 max-h-64 overflow-y-auto p-2 bg-gray-50 rounded">
//               {sectionOrder.map(section => (
//   sectionTotals?.[section] && (
//     <div key={section} className="flex justify-between items-center">
//       <span className="capitalize">
//         {section} ({sectionTotals[section].seats} seats)
//       </span>
//       <span className="font-medium">₹{sectionTotals[section].total}</span>
//     </div>
//   )
// ))}
//               </div>
//             </div>

//             <div className="flex justify-between pt-4 border-t border-gray-200">
//               <div className="flex items-center">
//                 <div className="w-3 h-3 bg-yellow-400 rounded-full mr-2"></div>
//                 <span className="text-sm">
//                   Available: {314 - summaryData.totalBookedSeats}
//                 </span>
//               </div>
//               <div className="flex items-center">
//                 <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
//                 <span className="text-sm">
//                   Sold: {summaryData.totalBookedSeats}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ShowPerformance;


// Akhilesh code

import React, { useState, useEffect } from "react";
import MovieServices from "../../services/externalServices/TicketServices/moviesServices";
import TheatreServices from "../../services/externalServices/TicketServices/theatreServices";
import ScreenLayoutServices from "../../services/externalServices/TicketServices/screenLayoutServices";
import { Ticket } from "lucide-react";
import axios from "axios";

const ShowPerformance = () => {
  const [movieName, setMovieName] = useState("");
  const [theatreName, setTheatreName] = useState("");
  const [showDate, setShowDate] = useState("");
  const [hour, setHour] = useState("");
  const [minute, setMinute] = useState("");
  const [period, setPeriod] = useState("");
  const [summaryData, setSummaryData] = useState(null);
  const [movies, setMovies] = useState([]);
  const [theatres, setTheatres] = useState([]);
  const [theatreId, setTheatreId] = useState("");
  const [showTimings, setShowTimings] = useState([]);
  const [error, setError] = useState(false);
  const { role = "", accessList = [] } = JSON.parse(
    localStorage.getItem("admin")
  );

  const isTicketAdmin = role === "ticket-admin";


  const theatreName1 = accessList?.[0];

  useEffect(() => {
    const fetchData = async () => {
      const theatreName = theatreName1;
      const movies = await MovieServices.getMoviesForShowPerformance(
        theatreName
      );
      setMovies(movies);

      const res = await TheatreServices.getTheatres();
      if (Array.isArray(res)) {
        let filtered = res;
        // if (role === "ticket-admin")
        //   filtered = res.filter((t) => accessList.includes(t.name));




        if (role === "ticket-admin") {
          filtered = res.filter((t) => accessList.includes(t.name));
        } else if (role === "earnings-report-only") {
          filtered = res.filter((t) => accessList.includes(t.name));
        }



        setTheatres(filtered);

        if (filtered.length > 0) {
          setTheatreId(filtered[0]._id);
          setTheatreName(filtered[0].name);
        }
      }
    };
    fetchData();
  }, []);

  const handleSummarySubmit = async (e) => {
    e.preventDefault();
    const formattedTime = `${hour}:${minute} ${period}`;
    const params = {
      movieName,
      theatreName,
      showDate: showDate.replace(/-/g, "/"),
      showTime: formattedTime,
    };
    try {
      const res = await ScreenLayoutServices.getSummary(params);
      setSummaryData(res);
    } catch (err) {
      console.error("Error fetching summary:", err);
    }
  };

  const fetchShowTimings = async (selectedMovieName, theatreId, showDate) => {
    const movie = movies.find((m) => m.name === selectedMovieName);
    if (movie && theatreId && showDate) {
      try {
        const response = await ScreenLayoutServices.getShowTimings({
          theatreId,
          showtimeId: movie._id,
          date: showDate,
        });
        setShowTimings(response);
      } catch (error) {
        console.error("Error fetching show timings:", error);
        setError(true);
        setShowTimings([]);
      }
    } else {
      setShowTimings([]);
    }
  };

  const seatPricePairs = summaryData?.bookedSeatList?.map((seat, index) => ({
    seat,
    price: summaryData.bookedPrices[index],
    section: seat.split(" ")[0],
  }));

  const sectionTotals = seatPricePairs?.reduce((acc, { section, price }) => {
    if (!acc[section]) {
      acc[section] = { total: 0, seats: 0 };
    }
    acc[section].total += price;
    acc[section].seats += 1;
    return acc;
  }, {});

  const sectionOrder = ["Platinum", "Silver", "Gold"];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <h2 className="text-xl font-semibold mb-4">Show Performance</h2>

        <form onSubmit={handleSummarySubmit} className="space-y-4">
          {/* Show Date Field - First */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Show Date
            </label>
            <input
              type="date"
              value={showDate}
              onChange={(e) => {
                const selectedDate = e.target.value;
                setShowDate(selectedDate);
                if (theatreId && movieName) {
                  fetchShowTimings(movieName, theatreId, selectedDate);
                }
              }}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>

          {/* Theatre Field - Second */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Theatre
            </label>
            <select
              value={theatreId}
              onChange={(e) => {
                const selectedTheatreId = e.target.value;
                const selectedTheatre = theatres.find(
                  (t) => t._id === selectedTheatreId
                );
                setTheatreId(selectedTheatreId);
                setTheatreName(selectedTheatre?.name || "");
                if (movieName && showDate) {
                  fetchShowTimings(movieName, selectedTheatreId, showDate);
                }
              }}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            >
              <option value="">Select a theatre</option>
              {theatres.map((t) => (
                <option key={t._id} value={t._id}>
                  {t.name}
                </option>
              ))}
            </select>
          </div>

          {/* Movie Field - Third */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Movie
            </label>
            <select
              value={movieName}
              onChange={(e) => {
                const selectedMovieName = e.target.value;
                setMovieName(selectedMovieName);
                if (theatreId && showDate) {
                  fetchShowTimings(selectedMovieName, theatreId, showDate);
                }
              }}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            >
              <option value="">Select a movie</option>
              {movies.map((m) => (
                <option key={m._id} value={m.name}>
                  {m.name}
                </option>
              ))}
            </select>
          </div>

          {/* Show Time Field - Fourth */}
          <div className="grid grid-cols-3 gap-2">
            {showTimings.length > 0 ? (
              <div className="space-y-2 col-span-3">
                <label className="block text-sm font-medium text-gray-700">
                  Show Time
                </label>
                <div className="flex flex-wrap gap-3">
                  {showTimings.map((timeObj, idx) => (
                    <label key={idx} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        value={timeObj.time}
                        checked={`${hour}:${minute} ${period}` === timeObj.time}
                        onChange={(e) => {
                          if (e.target.checked) {
                            const [timePart, ampm] = timeObj.time.split(" ");
                            const [h, m] = timePart.split(":");
                            setHour(h);
                            setMinute(m);
                            setPeriod(ampm);
                          } else {
                            setHour("");
                            setMinute("");
                            setPeriod("");
                          }
                        }}
                        className="form-checkbox text-blue-600"
                      />
                      <span className="text-sm text-gray-700">
                        {timeObj.time}
                      </span>
                    </label>
                  ))}
                </div>
              </div>
            ) : (
              <div className="col-span-3 text-sm text-gray-500 space-y-1">
                {!showDate && <p>Please select a date to view showtimes.</p>}
                {!theatreId && <p>Please select a theatre.</p>}
                {!movieName && <p>Please select a movie.</p>}
                {showDate && theatreId && movieName && !error && (
                  <p>
                    No showtimes found for the selected date, theatre, and movie.
                  </p>
                )}
                {error && (
                  <p className="text-red-500">
                    Error fetching showtimes. Please try again.
                  </p>
                )}
              </div>
            )}
          </div>

          <button
            type="submit"
            className="w-full bg-black text-white py-2 px-4 rounded-md hover:bg-gray-800 transition-colors"
          >
            Get Summary
          </button>
        </form>
      </div>

      {/* Ticket Summary Card remains the same */}
      {summaryData && (
        <div className="bg-white rounded-xl shadow-md p-6">
          <h2 className="text-xl font-semibold mb-4 flex gap-2 items-center">
            <Ticket /> Ticket Summary
          </h2>
          <div className="space-y-4">
            <div className="flex justify-between">
              <span className="font-medium">Booked Seats:</span>
              <span className="text-yellow-500">
                {summaryData.totalBookedSeats}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Total Earnings:</span>
              <span className="text-green-500">
                ₹{summaryData.totalEarnings}
              </span>
            </div>

            <div>
              <h3 className="font-medium mb-2">Seats & Pricing:</h3>
              <div className="space-y-3 max-h-64 overflow-y-auto p-2 bg-gray-50 rounded">
                {sectionOrder.map(
                  (section) =>
                    sectionTotals?.[section] && (
                      <div
                        key={section}
                        className="flex justify-between items-center"
                      >
                        <span className="capitalize">
                          {section} ({sectionTotals[section].seats} seats)
                        </span>
                        <span className="font-medium">
                          ₹{sectionTotals[section].total}
                        </span>
                      </div>
                    )
                )}
              </div>
            </div>

            <div className="flex justify-between pt-4 border-t border-gray-200">
              <div className="flex items-center">
                <div className="w-3 h-3 bg-indigo-500 rounded-full mr-2"></div>
                <span className="text-sm">Total Tickets: {314}</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 bg-yellow-400 rounded-full mr-2"></div>
                <span className="text-sm">
                  Available: {314 - summaryData.totalBookedSeats}
                </span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
                <span className="text-sm">
                  Sold: {summaryData.totalBookedSeats}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShowPerformance;
